import React from 'react';
import styles from './BubbleBadge.scss';
var BubbleBadge = function (_a) {
    var text = _a.text, image = _a.image;
    return (React.createElement("div", { className: styles.badges },
        React.createElement("div", { className: styles.wrapper, "aria-hidden": "true", "data-hook": "chat-badge-wrapper" },
            React.createElement("div", { className: styles.badge },
                image && (React.createElement("img", { "data-hook": "chat-badge-image", className: styles.icon, src: image, alt: text })),
                React.createElement("div", { className: styles.text, "data-hook": "chat-badge-text" }, text)))));
};
export default BubbleBadge;
//# sourceMappingURL=BubbleBadge.js.map